import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  // Renders the SMS consent paragraph. Only pass this on screens where the
  // action being agreed to actually sends an SMS.
  showSmsConsent: PropTypes.bool,
  // Label of the button that triggers the SMS, as the consent sentence names
  // it ("By tapping Send SMS, ...").
  smsCtaLabel: PropTypes.string,
  showDivider: PropTypes.bool,
  className: PropTypes.string,
};

// Legal disclosure shown underneath the auth/sign-up forms. The SMS consent
// wording is required by our carrier (Twilio) wherever we text the user.
const AuthLegalDisclosure = ({
  showSmsConsent = false,
  smsCtaLabel = 'Send SMS',
  showDivider = false,
  className,
}) => {
  const classes = classNames({
    'auth-legal-disclosure': true,
    [className]: !!className,
  });

  return (
    <Fragment>
      {showDivider && <hr className="auth-legal-disclosure-divider" />}
      <div className={classes}>
        <p>
          By continuing you agree to the{' '}
          <a href="/terms" target="_blank" rel="noopener noreferrer">
            Terms of Use
          </a>{' '}
          and{' '}
          <a href="/terms#privacy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          .
        </p>
        {showSmsConsent && (
          <Fragment>
            <p>
              By tapping {smsCtaLabel}, you also agree to receive automated text
              messages from Waldo Photos at this number, including your sign-in
              code and notifications when we find your photos. Consent to photo
              notifications is not required to use Waldo. Message frequency
              varies. Message and data rates may apply. Reply STOP to opt out or
              HELP for help.
            </p>
            <p>
              See our{' '}
              <a href="/terms#sms" target="_blank" rel="noopener noreferrer">
                SMS terms
              </a>
              .
            </p>
          </Fragment>
        )}
        <p>This site is protected by reCAPTCHA.</p>
      </div>
    </Fragment>
  );
};

AuthLegalDisclosure.propTypes = propTypes;

export default AuthLegalDisclosure;
